import h from 'react-hyperscript';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import Header from '../Header';
import Loading from '../Loading';
import HtmlAndCss from '../HtmlAndCss';
import styles from '../Course/course.css';


const HtmlAndCssRoute = ({ data: { loading, course, courses }, location, ...props}) => {
    if(loading) {
        return h('div', { className: styles.loadingContainer }, [h(Header), h(Loading, { center: true })]);
    } else {
        const singleCourse = location.query && location.query.course? course : null;
        const isOpen = singleCourse && singleCourse.state === 'open'? true : false;
        return h(HtmlAndCss, {isOpen, course: singleCourse, courses, location, ...props});
    }
};

export default graphql(gql`
    query($courseId: String){
        course(id: $courseId) {
            id
            name
            published
            state
            tbd
            startDate
            endDate

            university {
                name
            }
        }

        courses(where: { type: "html" }) {
            id
            name
            published
            state
            startDate
            endDate

            university {
                name
            }
        }
    }
`, {
    options({ location: { query: { course } }}) {
        return { variables: { courseId: course}};
    }
})(HtmlAndCssRoute);



/** WEBPACK FOOTER **
 ** ./src/HtmlAndCssRoute/index.js
 **/